module.exports = __webpack_public_path__ + "img/svg/bizum-footer.a671bf33135f71a880a51f633c27a017.svg";